import script from "./CardInfoEquipo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardInfoEquipo.vue?vue&type=script&setup=true&lang=ts"

import "./CardInfoEquipo.vue?vue&type=style&index=0&id=2d380f1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d380f1a"]])

export default __exports__